import { fontFaces } from './fontFaces';
import GlobalStyles from './globalStyles';
import { useFontsLoader } from './hooks/useFontsLoader';
import Router from './router';
import { BrowserRouter } from 'react-router-dom';
import { useInitAnalytics } from './hooks/useInitAnalytics';
import { useInitLocales } from './locales';
import { useEffect } from 'react';
import { Loader } from './components';

function App() {
  useFontsLoader(fontFaces);
  const { ready, isRtl } = useInitLocales();
  useInitAnalytics();

  useEffect(() => {
    document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
  }, [isRtl]);

  if (!ready) return <Loader />;

  return (
    <>
      <GlobalStyles />
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </>
  );
}

export default App;
